<template>
  <v-flex>
    <v-divider class="mt-3 mb-3" />
    <div
      v-if="false"
      class="v-message text-xs-center mt-3 mb-0"
    >
      <div class="v-messages__message">
        {{ $t('errors.form_not_valid') }}
      </div>
    </div>
    <v-layout
      :wrap="$vuetify.breakpoint.smAndDown"
      :justify-center="$vuetify.breakpoint.smAndDown"
      align-center
    >
      <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
      <v-flex shrink>
        <v-btn
          :loading="loader"
          color="sz_violet"
          class="mr-0 text-xs-center f-16"
          style="font-size: 16px"
          :disabled="loader"
          @click="validateForm"
        >
          {{ saveButtonTitle }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import scrollToTopErrorMessage from '@/mixins/scrollToTopErrorMessage';

export default {
    name: 'FurtherStoryButtons',
    mixins: [scrollToTopErrorMessage],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            loader: null
        };
    },
    computed: {
        saveButtonTitle () {
            return this.readOnly
                ? this.$t('further_story.note.button.go_to_card')
                : this.$t('buttons.save');
        },
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isPackageEmpty () {
            if (this.type === 'note' && this.family.meeting_notes) {
                return !this.family.meeting_notes.some((el) => {
                    return el.id === this.$route.params.noteId;
                });
            }
            if (this.type === 'summary') {
                return this.family.meetings_summary == null;
            }
            return false;
        }
    },
    methods: {
        validateForm () {
            if (this.readOnly) {
                this.$router.push({
                    name: 'family-card',
                    params: { id: this.$route.params.familyId }
                });
                return;
            }
            this.loader = true;
            this.$validator.validateAll().then((valid) => {
                if (valid === true) {
                    if (this.isPackageEmpty) {
                        this.saveData();
                    } else {
                        this.updateData();
                    }
                } else {
                    this.loader = false;
                    this.scrollToTopErrorMessage();
                }
            });
        },
        saveData () {
            this.$store
                .dispatch('furtherStory/saveData', {
                    familyId: this.$route.params.familyId,
                    type: this.type
                })
                .then(() => {
                    this.clearValidatorFlags();
                    this.$emit('finish', false);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        updateData () {
            const payload = {
                familyId: this.$route.params.familyId,
                type: this.type
            };
            if (this.$route.params.noteId) {
                payload.noteId = this.$route.params.noteId;
            }
            this.$store
                .dispatch('furtherStory/updateData', payload)
                .then(() => {
                    this.clearValidatorFlags();
                    this.$emit('finish', true);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
        clearValidatorFlags () {
            Object.keys(this.$validator.flags).forEach((x) => {
                this.$validator.flags[x].changed = false;
            });
        }
    }
};
</script>

<style scoped></style>
